
<template>

<page>
   
   <head-nav title="" :flex="false">
      <icon-button-hamburger slot="left"></icon-button-hamburger>
   </head-nav>
    
<scroll-page>
     
      <important-message/>
  
      <!-- GROUPS -->
        <divider title="language.divider_groups"/>

        <page-padding v-if="!computeGroupsAccess">{{$t('language.no_groups')}}</page-padding>
        <scroll-menu style="padding:10px 0">
            <group-button  v-for="(group, index) in groups" :key="index" :group="group"></group-button>
        </scroll-menu>
     
    
      <!-- ouder gesprekken -->
      <div v-if="appSettings.modules.teacher_talks=='1'">
        <featured-talks/>
      </div>
      

      <!-- chat -->
      <div v-if="appSettings.modules.chat=='1'">
        <list-chat-persons-featured/>
      </div>




      <!-- NEWS -->
      <div>
        <divider title="language.divider_news"/>
        <list-news-featured/>
      </div>

      <!-- CALENDAR -->
      <div v-if="appSettings.modules.calendar=='1'">
        <divider title="language.divider_calendar"/>
        <list-calendar-featured/>
      </div>


      <!-- PHOTO ALBUM -->
      <div v-if="appSettings.modules.pictures=='1'">
        <divider title="language.divider_photoalbum"/>
        <list-albums-featured/>
      </div>
      

      <!-- NEWSLETTERS -->
      <div v-if="appSettings.modules.newsletters=='1'">
        <divider title="language.divider_newsletters"/>
        <list-newsletters-featured/>
      </div>

      <!-- DOCUMENTS -->
      <div v-if="appSettings.modules.documents=='1'">
        <divider title="language.divider_documents"/>
        <list-documents-featured/>
      </div>



      <!-- absences -->
      <div v-if="appSettings.modules.absences=='1'">
        <divider title="language.divider_callsick"/>
        <list-absence-featured/>
      </div>
      <!--
      <page-padding>
        <button-more title="language.divider_callsick" to="/callsick" backgroundColor="#F46767"/>
      </page-padding>
      -->

      <app-footer/>
     
      

</scroll-page>
</page>
</template>

<script>

import Page from './Page.vue';
import ScrollMenu from '../components/scrollMenu/ScrollMenu.vue';
import GroupButton from '../components/buttons/GroupButton.vue';
import HeadNav from '../components/HeadNav.vue';
import IconButtonHamburger from '../components/buttons/IconButtonHamburger.vue';
import PagePadding from '../components/PagePadding.vue';
import Divider from '../components/dividers/Divider.vue';
import { mapState } from 'vuex';
import FeaturedTalks from '../components/talks/FeaturedTalks.vue';
import ListNewsFeatured from '../components/news/ListNewsFeatured.vue';
import ListCalendarFeatured from '../components/calendar/ListCalendarFeatured.vue';
import ListAlbumsFeatured from '../components/albums/ListAlbumsFeatured.vue';
import ListDocumentsFeatured from '../components/documents/ListDocumentsFeatured.vue';
import ListNewslettersFeatured from '../components/newsletters/ListNewslettersFeatured.vue';
import ListAbsenceFeatured from '../components/absence/ListAbsenceFeatured.vue';
import ImportantMessage from '../components/ImportantMessage.vue';
import AppFooter from '../components/AppFooter.vue';
//import HomePanel from '../components/HomePanel.vue';
import ScrollPage from '../components/ScrollPage.vue';
import ListChatPersonsFeatured from '../components/chat/ListChatPersonsFeatured.vue';
//import pushManager from '@/services/PushManager.js'

export default {
  name: 'HomePage',
  data(){
    return {
      medias:[],
    }
  },
  computed:{
    ...mapState(['groups','appSettings','teacher_talks']),
    computeGroupsAccess(){
        if(!this.groups){
          return false;
        }
        if(this.groups.length){
          return true;
        }

        return false;
        
      }
  },
  mounted(){
    //this.reg_test(new MouseEvent("click", { bubbles: true, cancelable: true, view: window }))
  },
  created(){
  },
  methods:{
  },
  components: {
    Page,
    GroupButton,
    HeadNav,
    IconButtonHamburger,
    PagePadding,
    ScrollMenu,
    Divider,
    ListNewsFeatured,
    ListCalendarFeatured, 
    ListAlbumsFeatured,
    ListDocumentsFeatured,
    ListNewslettersFeatured,
    ListAbsenceFeatured,
    ScrollPage,
    FeaturedTalks,
    AppFooter,
    ImportantMessage,
    ListChatPersonsFeatured,
    //HomePanel,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>
